// Which ONE notice the recording shows on a page other than Record: the
// live bar ("Recording 12:34 · Stop", or the upload still going) or the
// "Carry on?" question after a recording stopped on its own. Never both:
// the two used to stack, the fixed bar over the question. Pure, so the
// rule is tested (recorderBar.selftest.ts); RecordingBar.tsx draws it.

import type { RecorderPhase } from "./recorderEngine";

export type RecordingNotice = "none" | "live" | "offer";

/** The Record page says all of it itself. */
export const onRecordPage = (pathname: string) => /\/record\/?$/.test(pathname);

const capturing = (phase: RecorderPhase) => phase === "recording" || phase === "stopping";

/**
 * - a microphone is live (or saving its last seconds): the live bar; a held
 *   question waits until it is not;
 * - a question is held: the question, also while the microphone is asked
 *   for after "Carry on" (its button shows that it is working, and the strip
 *   does not jump away) and while the cut take still uploads (the question
 *   says what is still on this device; barWords says why it waits);
 * - parts still uploading: the live bar;
 * - otherwise nothing.
 */
export function recordingNotice(r: { phase: RecorderPhase; offer: unknown }, pathname: string): RecordingNotice {
  if (onRecordPage(pathname)) return "none";
  if (capturing(r.phase)) return "live";
  if (r.offer) return "offer";
  return r.phase === "uploading" ? "live" : "none";
}
